export default __webpack_public_path__ + "static/media/lazada.728e4721.png";